import React, { Component } from "react";
import { connect } from "react-redux";

import { useNavigate } from "../../utils/components/router";
import { basketActions, messageActions, pageActions, configActions } from "../../actions";
import FadedPanel from "../feedback.js";
import CONFIG from "../../config";
import { ArrowForwardIcon, ShoppingCartIcon, getProduktInfoIcon } from "../../utils/components/icons";
import Stepper from "../../utils/components/Stepper";
import { scrollToTop } from "../../utils/functions/scrollToTop.js";
import { Tooltip } from "../../utils/components/Tooltip";

class Item extends Component {
  constructor(props) {
    super(props);
    this.weiterLeitung = this.weiterLeitung.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleShowBasket = this.handleShowBasket.bind(this);
    this.handleClickAddToBasket = this.handleClickAddToBasket.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let item = state.item;
    // MaKond changes item price
    if (item && props.item && item.price !== props.item.price) {
      item = props.item.clone();
      item.changeAmount(state.item.amount);
    }
    return { ...state, item };
  }

  setFade() {
    this.setState({ fade: true });
    setTimeout(() => this.setState({ fade: false }), 1200);
  }

  state = {
    inBasket: false,
    item: this.props.item ? this.props.item.clone() : null
  };

  handleOnChange(value) {
    const item = this.props.item.clone();
    item.changeAmount(value);
    this.setState({ item });
  }

  getBasketFullMessage() {
    const maxBasketSize = this.props.basketStorage.getMaxBasketSize();
    let message = "Leider ist eine Bestellung über " + maxBasketSize + " Edelmetalle je Warenkorb nicht möglich.";
    if (this.props.configStorage.isAnkaufShop()) {
      message = "Ein Ankauf von mehr als " + maxBasketSize + " Position pro Warenkorb ist nicht möglich.";
    }
    return message;
  }

  handleClickAddToBasket() {
    const addItem = this.state.item.clone();
    addItem.basket = null;
    const maxSumText = this.props.basketStorage.getMaxSumText();
    const htmlId = this.props.configStorage.getHtmlId();

    if (this.props.basketStorage.isBasketFull()) {
      this.props.dispatch(messageActions.showMessage(htmlId, '.ser-adderbox', this.getBasketFullMessage()));
    } else if (
      this.props.basketStorage.isPriceTooHigh(addItem.brutto.getPrice()) && !this.props.configStorage.isAnkaufShop()
    ) {
      this.props.dispatch(
        messageActions.showMessage(
          htmlId,
          ".ser-adderbox",
          "Der Gegenwert übersteigt die Obergrenze von " +
          maxSumText +
          " Euro. Bitte reduzieren Sie den Gegenwert."
        )
      );
    } else if (
      this.props.basketStorage.isPriceTooHigh(
        this.props.basketStorage.sum.getPrice() + addItem.brutto.getPrice()
      ) && !this.props.configStorage.isAnkaufShop()
    ) {
      this.props.dispatch(
        messageActions.showMessage(
          htmlId,
          ".ser-adderbox",
          "Mit diesem Produkt übersteigt Ihr Warenkorb die Obergrenze von " +
          maxSumText +
          " Euro. Bitte reduzieren Sie die gewählte Menge oder entfernen Produkte aus Ihrem Warenkorb."
        )
      );
    } else if (this.props.configStorage.isAnkaufShop()) {
      // ✅ Ankauf: validate WITHOUT modifying real basket
      const currentSum = this.props.basketStorage.sum.getPrice();
      const newSum = currentSum + addItem.brutto.getPrice();
      const numericLimit = this.props.basketStorage.numericLimit;

      if (
        numericLimit !== null &&
        !isNaN(numericLimit) &&
        newSum > numericLimit
      ) {
      const formattedLimit =
        this.props.basketStorage.numericLimit !== null && !isNaN(this.props.basketStorage.numericLimit)
          ? this.props.basketStorage.numericLimit.toLocaleString("de-DE")
          : "";

      const warningMessage =
        "Mit diesem Produkt übersteigt Ihr Ankauf die zulässige Obergrenze von {value} Euro. Bitte reduzieren Sie die gewählte Menge.".replace(
          "{value}",
          formattedLimit
        );

        this.props.dispatch(
          messageActions.showWarningMessage(
            htmlId,
            ".ser-adderbox",
            warningMessage,
            "50%",
            "25%"
          )
        );
        return;
      }

      this.props.dispatch(basketActions.addItem(addItem));

      const item = this.props.item.clone();
      item.changeAmount(1);
      this.setState({
        inBasket: true,
        fade: true,
        item
      });
      this.setFade();
      if (this.props.configStorage.sessionWillEnd()) {
        this.props.dispatch(
          configActions.restartSession(
            this.props.configStorage.getRequestData("session_ping")
          )
        );
      }
    } else {
      // ✅ Verkauf normal flow
      this.props.dispatch(basketActions.addItem(addItem));

      const item = this.props.item.clone();
      item.changeAmount(1);
      this.setState({
        inBasket: true,
        fade: true,
        item
      });
      this.setFade();
      if (this.props.configStorage.sessionWillEnd()) {
        this.props.dispatch(
          configActions.restartSession(
            this.props.configStorage.getRequestData("session_ping")
          )
        );
      }
    }
  }

  handleShowBasket() {
    if (this.props.basketStorage.numItems() > 0) {
      this.props.dispatch(pageActions.setCartPage());
      if (this.props.configStorage.sessionWillEnd()) {
        this.props.dispatch(configActions.restartSession(this.props.configStorage.getRequestData("session_ping")));
      }
    } else {
      let txt = "Sie haben noch keine Produkte in den Warenkorb gelegt.";
      this.props.dispatch(
        messageActions.showMessage(
          this.props.configStorage.getHtmlId(),
          ".ser-basketanchor",
          txt
        )
      );
    }
  }

  weiterLeitung() {
    scrollToTop();
    return this.props.navigate(CONFIG.LINK_EMPFEHLUNG + this.props.item.getLinkId());
  }

  render() {
    let item = this.state.item;
    if (!item) return null;
    return (
      <li
        id={this.props.configStorage.getHtmlId() + "-" + item.kennziffer}
        className="ser-item ser-iblock"
        aria-label={"Produkt: " + item.name}
      >
        <button
          type="button"
          className="col-12 justify-content-center btn-link ser-image-button"
          onClick={this.weiterLeitung}
          aria-label={item.name + " Details anzeigen"}
        >
          <img
            alt={"Bild für " + item.name}
            className="img-responsive"
            src={this.props.configStorage.getImgUrl(item.image)}
          />
        </button>
        <div className="ser-itembox p-one pt-0 pt-lg-1">
          <div className="ser-section row" aria-live="polite">
            <span className="ser-label ser-iblock col-10">
              <h4 className="itemTitle" aria-level="3">
                <button
                  type="button"
                  className="btn btn-link btn-lg text-dark text-start fs-3 lh-1"
                  onClick={this.weiterLeitung}
                  aria-label={item.name + " Details anzeigen"}
                >
                  {item.name}
                </button>
              </h4>
            </span>
            <span className="col-2">
              <Tooltip className="fs-8 mt-2" icon={getProduktInfoIcon()}>{item.produktInfo}</Tooltip>
            </span>
          </div>
          <div className="ser-section row">
            <span className="ser-label ser-iblock col-6">Stückpreis:</span>
            <span className="ser-grey text-end col-6">{item.itemprice.toEuro()}</span>
          </div>
          <div className="ser-section row">
            <span className="ser-label ser-iblock col-6">MwSt.:</span>
            <span className="ser-grey text-end col-6">{item.tax.toEuro()}</span>
          </div>
          <div className="ser-section row">
            <label className="col-6" htmlFor={"stk" + item.kennziffer}>
              <span className="ser-label ser-iblock">Stückzahl:</span>
            </label>
            <div className="ser-stepper-section col-6">
              <Stepper
                item={item}
                label={"Stückzahl von " + item.name}
                disabled={this.props.basketStorage.locked}
                onChange={this.handleOnChange}
                id={"stk" + item.kennziffer}
              />
            </div>
          </div>
          <div className="ser-section row" aria-live="polite">
            <span className="ser-label ser-iblock ser-ovpricelabel col-6">
              Preis inkl. Steuer:
            </span>
            <span className="ser-red text-end col-6">{item.brutto.toEuro()}</span>
            {this.props.configStorage.isKundenShop() || this.props.configStorage.isLightShop()
              ? <span className="fs-6 col-12 ser-label">
                {this.props.configStorage.isLightShop()
                  ? "ggf. zuzüglich Versand- und Bearbeitungsgebühren"
                  : <>zzgl. {this.props.basketStorage.getShippingCosts().toEuro()} für Versand nach Hause</>
                }
              </span>
              : null
            }
          </div>
        </div>

        <div className="ser-overlayWrapper" aria-label="Zum Warenkorb">
          <FadedPanel fade={this.state.fade} />
          <div className={"ser-adderbox" + (this.props.basketStorage.isBasketFull() ? " p-1" : "")}>
            {!this.props.configStorage.isLightShop() ?
              (!this.props.basketStorage.isBasketFull()
                ? <button type="button"
                  className="ser-basketadder ser-iblock btn-link float-end"
                  onClick={this.handleClickAddToBasket}
                  aria-label={item.amount + " " + item.name + " in den Warenkorb legen"}
                >
                  In den Warenkorb
                  <ArrowForwardIcon />
                </button>
                : <div className="ser-basketadder ser-ibloc text-center fs-6">
                  {this.getBasketFullMessage()}
                </div>
              )
            : null}
            <button type="button"
              aria-label="Warekorb öffnen"
              className={"btn-link float-start " + (this.state.inBasket ? "d-block" : "d-none")}
              onClick={this.handleShowBasket}
            >
              <ShoppingCartIcon />
            </button>
          </div>
        </div>
      </li>
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    configStorage: store.configStorage,
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <Item {...props} navigate={contextNavigate}></Item>;
});
